import { createSelector } from 'reselect';

import {
  // Props
  localeSelector,
  propSelector,
  // Navigation
  navigationImprintSelector,
  navigationTAndCSelector,
  navigationPrivacyAtXingSelector,
  navigationPrivacyPolicySelector,
} from '../selectors';
import { localizedLink } from '../selectors/utils';

export default createSelector(
  [
    localeSelector,
    propSelector,
    navigationImprintSelector,
    navigationTAndCSelector,
    navigationPrivacyAtXingSelector,
    navigationPrivacyPolicySelector,
  ],
  (locale, props, imprint, tAndC, privacyAtXing, privacyPolicy) => {
    return {
      links: [imprint, tAndC, privacyAtXing, privacyPolicy].map(
        localizedLink(locale)
      ),
      ...props,
    };
  }
);
